import { cn } from '../../utils'
import { useTranslation } from 'react-i18next'
import { Loader } from '../Loader'

/**
 * Spinner + text, positioned as ONE unit.
 *
 * Defaults to the centre of the viewport. `className` repositions the whole
 * wrapper (e.g. `!absolute` centres it in the nearest relative parent), so
 * the icon and the text can never end up in different places. They used to
 * be positioned separately — the icon through `className`, the text with its
 * own hard-coded `fixed` — and the translate classes were invalid, so neither
 * was actually centred.
 */
export const Loading = ({
    className,
    text,
}: {
    className?: string
    text?: string
}) => {
    const { t } = useTranslation(['common'])
    const loadingText = text || t('table-states.loading') || ''
    return (
        <div
            role="status"
            aria-live="polite"
            className={cn(
                'fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 whitespace-nowrap',
                className
            )}
        >
            <Loader
                text={loadingText}
                variant="contained"
                size="md"
                color="gradient"
                strokeColor="fill-background-gradient"
                textClassName="!text-background-primary ml-0"
            />
        </div>
    )
}
